// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "short_link".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "short_link" table (1:1 with a DB row, on the wire). */
export const shortLinkAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    conversationId: z.string().nullable(),
    tokenHash: z.string(),
    promptVariant: z.string().nullable(),
    destinationUrl: z.string(),
    expiresAt: z.string().datetime(),
    humanClickCount: z.number(),
    botClickCount: z.number(),
    firstHumanClickedAt: z.string().datetime().nullable(),
    lastClickedAt: z.string().datetime().nullable(),
    bookedAt: z.string().datetime().nullable(),
    appointmentId: z.string().nullable(),
    createdAt: z.string().datetime(),
});
//# sourceMappingURL=shortLink.js.map